import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'src/app/components/components.module';
import { AgricultorComponent } from './agricultor.component';

@NgModule({
  declarations: [
    AgricultorComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule
  ]
})
export class AgricultorModule { }
